export var isSystemAgent = function isSystemAgent(agent) {
  return agent.creator_type === 'SYSTEM';
};
export var isCustomerAgent = function isCustomerAgent(agent) {
  return agent.creator_type === 'CUSTOMER';
};
// BE will deprecate THIRD_PARTY and use FORGE instead
export var isForgeAgent = function isForgeAgent(agent) {
  return agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
};
export var isPrivateAgent = function isPrivateAgent(agent) {
  return agent.visibility === 'PRIVATE';
};
export var isOOTBAgent = function isOOTBAgent(agent) {
  return agent.creator_type === 'OOTB';
};
export var BrowseCategories = {
  ALL_AGENTS: 'all-agents',
  STARRED_AGENTS: 'starred-agents',
  MY_AGENTS: 'my-agents',
  TEMPLATES: 'templates',
  DEVELOPMENT: 'development'
};